import PeopleCardRoute from '../../store/schema/PeopleCardRoute';
import PeopleCardRouteIdType from 'mini-people-common/lib/schema/PeopleCardRouteIdType';
import reloadPeopleCardMutator from '../../mutators/reloadPeopleCardMutator';

/**
 *  Handle route state creation on landing directly on card view.
 */
export function peopleCardRouterHandler(params: PeopleCardRoute) {
    reloadPeopleCardMutator(params);
    return false;
}

/**
 * Handle cleanup task for people card.
 * Reset/update the CardRoute store only when we move out/close the PeopleCard URLs.
 * .i.e.
 * Change in route from "/people/card/pid/abc" to "/people/card/pid/abc" should not update the CardRouteStore
 * whereas change in route from "/people/card/pid/abc" to "/people" should
 */
export function peopleCardRouteCleanup(
    oldRoute: string[],
    oldParams: PeopleCardRoute,
    newRoute: string[],
    newParams: PeopleCardRoute
) {
    if (!newParams || !newParams.routeIdType) {
        reloadPeopleCardMutator({
            routeId: null,
            routeIdType: PeopleCardRouteIdType.None,
            view: null,
        });
    }
    return false;
}
